<template>
  <div class="mapa-wrapper">
    <!-- Header Flutuante (Estilo Card) -->
    <header class="floating-header">
      <router-link to="/" class="header-logo-link">
         <img src="@/assets/images/logo-azul.svg" alt="OligoCheck" />
      </router-link>
      
      <div class="header-actions">
        <button class="icon-btn" @click="openSearchModal">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
          <span class="tooltip-text">Buscar Clínica</span>
        </button>
        <button class="icon-btn" @click="locateUser">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="22" y1="12" x2="18" y2="12"></line><line x1="6" y1="12" x2="2" y2="12"></line><line x1="12" y1="6" x2="12" y2="2"></line><line x1="12" y1="22" x2="12" y2="18"></line></svg>
          <span class="tooltip-text">Minha Localização</span>
        </button>
        <a :href="`https://api.whatsapp.com/send/?phone=34617488404&text=${encodeURIComponent(t.ctaMessage)}&type=phone_number&app_absent=0`" target="_blank" class="icon-btn">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>
          <span class="tooltip-text">Adquirir Oligocheck</span>
        </a>
        <button class="icon-btn" v-if="showAdminLogin" @click="openLoginModal">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path><polyline points="10 17 15 12 10 7"></polyline><line x1="15" y1="12" x2="3" y2="12"></line></svg>
          <span class="tooltip-text">Área Restrita</span>
        </button>
      </div>

      <div class="lang-switcher">
        <div class="current-lang" @click="toggleLangMenu">
          <img :src="currentLangFlag" :alt="currentLang" class="flag-icon" />
          <span class="lang-arrow">
            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>
          </span>
        </div>
        
        <div class="lang-menu" v-if="showLangMenu">
          <button @click="changeLang('pt')" :class="{ active: currentLang === 'pt' }">
            <img src="https://flagcdn.com/w20/br.png" alt="PT" /> Português
          </button>
          <button @click="changeLang('es')" :class="{ active: currentLang === 'es' }">
            <img src="https://flagcdn.com/w20/es.png" alt="ES" /> Español
          </button>
          <button @click="changeLang('en')" :class="{ active: currentLang === 'en' }">
            <img src="https://flagcdn.com/w20/us.png" alt="EN" /> English
          </button>
        </div>
      </div>
    </header>

    <!-- Sidebar controla visibilidade visual via CSS 'open', mas o conteúdo permanece no DOM se activeClinic existir -->
    <div class="sidebar" :class="{ 'open': sidebarVisible }">
      <button class="close-btn-absolute" @click="closeSidebar">
         <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
      </button>
      
      <div class="clinics-list" v-if="activeClinic">
        <div class="clinic-card">
          <div class="clinic-header-profile">
            <div class="logo-wrapper">
              <img 
                :key="activeClinic.id"
                :src="activeClinic.logo" 
                @error="handleImageError" 
                class="clinic-logo-large" 
              />
            </div>
            <div class="text-content">
              <h4>{{ activeClinic.name }}</h4>
              
              <!-- Google Rating Badge -->
              <div class="google-badge" v-if="activeClinic.rating">
                <span class="stars">
                  ★ {{ activeClinic.rating }}
                </span>
                <span class="reviews" v-if="activeClinic.reviewsCount">
                  ({{ activeClinic.reviewsCount }} avaliações)
                </span>
              </div>

            </div>
          </div>

          <div class="divider"></div>

          <div class="clinic-actions-grid">
             <!-- WhatsApp -->
             <button class="action-card whatsapp" @click="openLink(formatWhatsAppLink(activeClinic.whatsapp))" v-if="activeClinic.whatsapp">
               <div class="icon-box">
                 <img src="@/assets/images/icone-whatsapp.png" alt="WhatsApp" />
               </div>
               <span>WhatsApp</span>
             </button>

             <!-- Rota / Maps (Prioriza Link do GMB se existir) -->
             <button class="action-card maps" @click="openLink(activeClinic.gmbLink || `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(activeClinic.address)}`)" v-if="activeClinic.address || activeClinic.gmbLink">
               <div class="icon-box">
                 <img src="@/assets/images/icone-localizacao.svg" alt="Mapa" />
               </div>
               <span>{{ activeClinic.gmbLink ? t.viewOnGoogle : t.directions }}</span>
             </button>

             <!-- Instagram -->
             <button class="action-card instagram" @click="openLink(activeClinic.instagram)" v-if="activeClinic.instagram">
               <div class="icon-box">
                  <img src="@/assets/images/icone-instagram.png" alt="Instagram" />
               </div>
               <span>Instagram</span>
             </button>

             <!-- Site (Novo - Placeholder se não tiver campo ainda, ou condicional) -->
             <button class="action-card website" @click="openLink(activeClinic.website || '#')" v-if="activeClinic.website">
               <div class="icon-box">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="2" y1="12" x2="22" y2="12"></line><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path></svg>
               </div>
               <span>Website</span>
             </button>
          </div>

          <div class="address-block" v-if="activeClinic.address">
             <div class="address-label">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
                {{ t.fullAddress }}
             </div>
             <p>{{ activeClinic.address }}</p>
          </div>

        </div>
      </div>
    </div>

    <!-- Modal de Busca -->
    <Transition name="search-anim">
      <div class="search-modal-overlay" v-if="showSearchModal" @click.self="closeSearchModal">
        <div class="search-modal">
          <div class="search-header">
             <div class="input-wrapper">
               <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
               <input 
                 v-model="searchQuery" 
                 :placeholder="t.searchPlaceholder || 'Buscar clínica...'" 
                 ref="searchInput" 
                 autofocus
               />
             </div>
             <button class="close-search-btn" @click="closeSearchModal">
               <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
             </button>
          </div>
          
          <div class="search-results">
             <div 
               v-for="clinic in filteredClinics" 
               :key="clinic.id" 
               class="search-result-item"
               @click="selectSearchedClinic(clinic)"
             >
               <div class="result-icon">
                 <img :src="clinic.logo" @error="handleImageError" alt="logo" />
               </div>
               <div class="result-info">
                 <strong>{{ clinic.name }}</strong>
                 <small>{{ clinic.address }}</small>
               </div>
             </div>
             
             <div v-if="filteredClinics.length === 0 && searchQuery.length > 0" class="no-results">
               <p>{{ t.noResults || 'Nenhuma clínica encontrada' }}</p>
             </div>
          </div>
        </div>
      </div>
    </Transition>

    <!-- Modal de Login -->
    <Transition name="search-anim">
      <div class="login-modal-overlay" v-if="showLoginModal" @click.self="closeLoginModal">
        <div class="login-modal">
           <div class="login-header">
              <h3>Acesso Restrito</h3>
              <button class="close-search-btn" @click="closeLoginModal">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
              </button>
           </div>
           <div class="login-body">
              <form @submit.prevent="handleLogin">
                <div class="form-group">
                  <label>E-mail</label>
                  <div class="input-wrapper">
                    <input type="email" v-model="loginEmail" placeholder="admin@exemplo.com" required />
                  </div>
                </div>
                <div class="form-group">
                  <label>Senha</label>
                  <div class="input-wrapper">
                    <input type="password" v-model="loginPassword" placeholder="••••••••" required />
                  </div>
                </div>
                
                <div class="error-message" v-if="loginError">
                  {{ loginError }}
                </div>

                <button type="submit" class="btn-login" :disabled="isLoggingIn">
                  <span v-if="!isLoggingIn">Entrar</span>
                  <span v-else>Carregando...</span>
                </button>
              </form>
           </div>
        </div>
      </div>
    </Transition>

    <div class="map-content">
      <l-map 
        ref="map" 
        v-model:zoom="zoom" 
        v-model:center="center" 
        :use-global-leaflet="false"
        :min-zoom="3"
        :max-zoom="18"
        :max-bounds="maxBounds"
        :options="{ worldCopyJump: true, zoomControl: false }"
        style="height: 100%; width: 100%;"
        @click="closeSidebar"
      >
        <l-control-zoom position="bottomright"></l-control-zoom>
        <l-tile-layer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          layer-type="base"
          name="OpenStreetMap"
        ></l-tile-layer>

        <!-- Marcador do Usuário (Pino Vermelho) -->
        <l-marker
          v-if="userLocation"
          :lat-lng="userLocation"
          :z-index-offset="1000"
        >
          <l-icon
            icon-url="https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png"
            shadow-url="https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png"
            :icon-size="[25, 41]"
            :icon-anchor="[12, 41]"
            :popup-anchor="[1, -34]"
            :shadow-size="[41, 41]"
          />
          <l-tooltip>
            <div class="custom-tooltip">
               Sua Localização
            </div>
          </l-tooltip>
        </l-marker>

        <l-marker
          v-for="clinic in animatedMarkers"
          :key="clinic.uniqueKey"
          :lat-lng="clinic.coords"
          @click="selectClinic(clinic)"
        >
          <l-tooltip>
            <div class="custom-tooltip">
              <b>{{ clinic.name }}</b>
              <br/>
              {{ clinic.address }}
            </div>
          </l-tooltip>
        </l-marker>
      </l-map>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed, reactive, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import "leaflet/dist/leaflet.css";
import { LMap, LTileLayer, LMarker, LTooltip, LControlZoom, LIcon } from "@vue-leaflet/vue-leaflet";
import { db, auth } from "@/firebaseConfig";
import { collection, getDocs, doc, updateDoc } from "firebase/firestore";
import { signInWithEmailAndPassword } from "firebase/auth";
const defaultImage = 'https://firebasestorage.googleapis.com/v0/b/system-oligocheck.appspot.com/o/clinics%2F1757882609228_SOCHECK.jpeg?alt=media&token=6b02c18c-cc05-4d35-a4c3-f3074e6b4c3f';
import { paises } from '@/data/paises.js';

const route = useRoute();
const router = useRouter();
const showAdminLogin = computed(() => route.query.admin !== undefined);

// Login State
const showLoginModal = ref(false);
const loginEmail = ref('');
const loginPassword = ref('');
const loginError = ref('');
const isLoggingIn = ref(false);

const openLoginModal = () => {
  showLoginModal.value = true;
  loginEmail.value = '';
  loginPassword.value = '';
  loginError.value = '';
};

const closeLoginModal = () => {
  showLoginModal.value = false;
};

const handleLogin = async () => {
  if (!loginEmail.value || !loginPassword.value) {
    loginError.value = "Preencha todos os campos";
    return;
  }
  
  isLoggingIn.value = true;
  loginError.value = '';

  try {
    await signInWithEmailAndPassword(auth, loginEmail.value, loginPassword.value);
    router.push('/admin/dashboard');
    closeLoginModal();
  } catch (e) {
    console.error(e);
    if (e.code === 'auth/invalid-credential' || e.code === 'auth/user-not-found' || e.code === 'auth/wrong-password') {
      loginError.value = 'Credenciais inválidas.';
    } else {
      loginError.value = 'Erro ao conectar. Tente novamente.';
    }
  } finally {
    isLoggingIn.value = false;
  }
};

// Lang State
const currentLang = ref('es');
const showLangMenu = ref(false);

  const flags = {
  pt: 'https://flagcdn.com/w40/br.png',
  es: 'https://flagcdn.com/w40/es.png',
  en: 'https://flagcdn.com/w40/us.png'
};

const currentLangFlag = computed(() => flags[currentLang.value]);

// Dicionário de Traduções
const translations = {
  pt: {
    whatsapp: 'WhatsApp',
    directions: 'Como Chegar',
    viewOnGoogle: 'Ver no Google',
    instagram: 'Instagram',
    website: 'Website',
    fullAddress: 'Endereço Completo',
    location: 'Localização',
    ctaButton: 'ADQUIRIR OLIGOCHECK',
    ctaMessage: 'Olá! Vi o mapa de clínicas e gostaria de mais informações sobre o OligoCheck.',
    reviews: 'avaliações',
    searchPlaceholder: 'Buscar clínica...',
    noResults: 'Nenhuma clínica encontrada'
  },
  es: {
    whatsapp: 'WhatsApp',
    directions: 'Cómo llegar',
    viewOnGoogle: 'Ver en Google',
    instagram: 'Instagram',
    website: 'Sitio Web',
    fullAddress: 'Dirección Completa',
    location: 'Ubicación',
    ctaButton: 'ADQUIRIR OLIGOCHECK',
    ctaMessage: 'Hola! He visto el mapa de clínicas y me gustaría más información sobre OligoCheck.',
    reviews: 'reseñas',
    searchPlaceholder: 'Buscar clínica...',
    noResults: 'No se encontraron clínicas'
  },
  en: {
    whatsapp: 'WhatsApp',
    directions: 'Get Directions',
    viewOnGoogle: 'View on Google',
    instagram: 'Instagram',
    website: 'Website',
    fullAddress: 'Full Address',
    location: 'Location',
    ctaButton: 'GET OLIGOCHECK',
    ctaMessage: 'Hello! I saw the clinics map and would like more info about OligoCheck.',
    reviews: 'reviews',
    searchPlaceholder: 'Search clinic...',
    noResults: 'No clinics found'
  }
};

// Computed para retornar os textos do idioma atual
const t = computed(() => translations[currentLang.value]);

// Search Logic
const showSearchModal = ref(false);
const searchQuery = ref('');
const searchInput = ref(null);

const openSearchModal = () => {
  showSearchModal.value = true;
  setTimeout(() => {
    if (searchInput.value) {
      searchInput.value.focus();
    }
  }, 100);
};

const closeSearchModal = () => {
  showSearchModal.value = false;
  searchQuery.value = '';
};

const filteredClinics = computed(() => {
  if (!searchQuery.value) return [];
  const query = searchQuery.value.toLowerCase();
  return clinics.value.filter(clinic => 
    (clinic.name && clinic.name.toLowerCase().includes(query)) || 
    (clinic.address && clinic.address.toLowerCase().includes(query))
  ).slice(0, 10); // Limit results
});

const selectSearchedClinic = (clinic) => {
  // 1. Fecha o modal de busca primeiro para limpar a tela
  closeSearchModal();
  // 2. Fecha qualquer sidebar aberta anteriormente
  closeSidebar();
  
  const clinicWithCoords = clinicsWithCoords.value.find(c => c.id === clinic.id);
  
  if (clinicWithCoords) {
      const mapInstance = map.value?.leafletObject;
      
      if (mapInstance) {
          let targetLatLng = clinicWithCoords.coords;

          // Ajuste para Mobile: Deslocar o centro para que o pino não fique atrás da sidebar
          if (window.innerWidth <= 768) {
              const targetZoom = 16;
              // Projeta a coordenada da clínica para pixels (no zoom alvo)
              const point = mapInstance.project(targetLatLng, targetZoom);
              
              // Desloca o ponto central do mapa para baixo (somando Y), 
              // fazendo o pino da clínica subir visualmente para a área livre.
              // Reduzido de 250 para 150 para não ficar escondido no topo
              point.y += 150; 
              
              const newCenter = mapInstance.unproject(point, targetZoom);
              targetLatLng = [newCenter.lat, newCenter.lng];
          }

          const duration = 1.5;

          mapInstance.flyTo(targetLatLng, 16, {
              animate: true,
              duration: duration
          });

          // Abre a sidebar apenas após a animação terminar
          setTimeout(() => {
            selectClinic(clinic);
          }, duration * 1000);

      } else {
          center.value = clinicWithCoords.coords;
          zoom.value = 16;
          selectClinic(clinic);
      }
  } else {
      selectClinic(clinic);
  }
};

const toggleLangMenu = () => {
  showLangMenu.value = !showLangMenu.value;
};

const changeLang = (lang) => {
  currentLang.value = lang;
  showLangMenu.value = false;
};

const zoom = ref(3);
const center = ref([20, 0]); 
const map = ref(null);
const userLocation = ref(null);

const maxBounds = [
  [-85, -Infinity],
  [85, Infinity]
];
const clinics = ref([]);

// Estado separado para Dados vs Visibilidade
const activeClinic = ref(null);
const sidebarVisible = ref(false);
const lastSelectionTimestamp = ref(0);

const clinicCoordinates = reactive({}); 

// Country coordinates for fallback
const countryCoords = {
  "España": [40.4637, -3.7492],
  "Portugal": [39.3999, -8.2245],
  "Brasil": [-14.2350, -51.9253],
  "Estados Unidos de América": [37.0902, -95.7129],
  "Francia": [46.2276, 2.2137],
  "Italia": [41.8719, 12.5674],
  "Alemania": [51.1657, 10.4515],
  "Reino Unido": [55.3781, -3.4360],
  "Argentina": [-38.4161, -63.6167],
  "Chile": [-35.6751, -71.5430],
  "Colombia": [4.5709, -74.2973],
  "México": [23.6345, -102.5528],
  "Perú": [-9.1900, -75.0152],
  "Uruguay": [-32.5228, -55.7658],
  "Paraguay": [-23.4425, -58.4438],
  "Bolivia": [-16.2902, -63.5887],
  "Ecuador": [-1.8312, -78.1834],
  "Venezuela": [6.4238, -66.5897],
  "Costa Rica": [9.7489, -83.7534],
  "Panamá": [8.5380, -80.7821],
  "República Dominicana": [18.7357, -70.1627],
  "Puerto Rico": [18.2208, -66.5901],
  "Cuba": [21.5218, -77.7812],
  "Andorra": [42.5063, 1.5218],
  "Suiza": [46.8182, 8.2275],
  "Bélgica": [50.5039, 4.4699],
  "Países Bajos": [52.1326, 5.2913],
  "Suecia": [60.1282, 18.6435],
  "Noruega": [60.4720, 8.4689],
  "Dinamarca": [56.2639, 9.5018],
  "Finlandia": [61.9241, 25.7482],
  "Polonia": [51.9194, 19.1451],
  "Irlanda": [53.1424, -7.6921],
  "Australia": [-25.2744, 133.7751],
  "Nueva Zelanda": [-40.9006, 174.8860],
  "Japón": [36.2048, 138.2529],
  "China": [35.8617, 104.1954],
  "India": [20.5937, 78.9629],
  "Canadá": [56.1304, -106.3468],
  "Rusia": [61.5240, 105.3188],
  "Sudáfrica": [-30.5595, 22.9375],
  "Israel": [31.0461, 34.8516],
  "Turquía": [38.9637, 35.2433],
  "Grecia": [39.0742, 21.8243],
  "Emiratos Árabes Unidos": [23.4241, 53.8478],
};

// Computed: Gera lista de clínicas com suas coordenadas (reais ou estimadas)
const clinicsWithCoords = computed(() => {
  const markers = [];
  
  clinics.value.forEach(clinic => {
    let lat, lng;

    // 1. Tenta usar lat/lng salvo no banco ou cache local
    if (clinic.lat && clinic.lng) {
      lat = parseFloat(clinic.lat);
      lng = parseFloat(clinic.lng);
    } else if (clinicCoordinates[clinic.id]) {
      [lat, lng] = clinicCoordinates[clinic.id];
    } 
    // 2. Fallback: Usa o centro do país com "jitter" (espalhamento aleatório)
    else {
      const country = identifyCountry(clinic.address);
      const baseCoords = countryCoords[country];
      
      if (baseCoords) {
        // Adiciona um desvio aleatório para não empilhar todos no mesmo ponto
        // +/- 2 graus é suficiente para espalhar visivelmente num país
        const jitter = 2.0; 
        lat = baseCoords[0] + (Math.random() - 0.5) * jitter;
        lng = baseCoords[1] + (Math.random() - 0.5) * jitter;
      }
    }

    if (lat && lng) {
      // Adiciona marcador original
      markers.push({
        ...clinic,
        uniqueKey: clinic.id,
        coords: [lat, lng]
      });
      
      // Adiciona cópias para "mundo infinito"
      markers.push({
        ...clinic,
        uniqueKey: `${clinic.id}-left`,
        coords: [lat, lng - 360]
      });
      markers.push({
        ...clinic,
        uniqueKey: `${clinic.id}-right`,
        coords: [lat, lng + 360]
      });
    }
  });
  
  return markers;
});

// --- Lógica de Animação dos Pinos ---
const animatedMarkers = ref([]);

watch(clinicsWithCoords, (allMarkers) => {
  const currentIds = new Set(animatedMarkers.value.map(m => m.uniqueKey));
  
  // Novos markers que ainda não estão na tela
  const toAdd = allMarkers.filter(m => !currentIds.has(m.uniqueKey));
  
  // Markers que sumiram dos dados originais (devem ser removidos)
  const allIds = new Set(allMarkers.map(m => m.uniqueKey));
  const toRemove = animatedMarkers.value.filter(m => !allIds.has(m.uniqueKey));
  
  // Remove imediatamente os que não existem mais
  if (toRemove.length > 0) {
      animatedMarkers.value = animatedMarkers.value.filter(m => allIds.has(m.uniqueKey));
  }

  // Adiciona os novos com efeito sequencial
  if (toAdd.length > 0) {
      animateAddition(toAdd);
  }
}, { immediate: true, deep: true });

const animateAddition = async (items) => {
    // Ajusta a velocidade: muitos itens = mais rápido
    const delay = items.length > 20 ? 20 : 50;
    
    for (const item of items) {
        animatedMarkers.value.push(item);
        // Pequeno delay para criar o efeito de "pop" um por um
        await new Promise(r => setTimeout(r, delay));
    }
};
// ------------------------------------

const identifyCountry = (address) => {
    if (!address) return "Outros";
    const lowerAddr = address.toLowerCase();
    
    for (const country of paises) {
        if (lowerAddr.includes(country.toLowerCase())) return country;
    }
    
    // Common aliases
    if (lowerAddr.includes('spain')) return "España";
    if (lowerAddr.includes('brazil')) return "Brasil";
    if (lowerAddr.includes('usa') || lowerAddr.includes('united states')) return "Estados Unidos de América";
    
    return "Outros";
};

const fetchClinics = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, "clinics"));
    clinics.value = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    
    // Preload de imagens para evitar delay
    clinics.value.forEach(clinic => {
      if (clinic.logo) {
        const img = new Image();
        img.src = clinic.logo;
        if (img.decode) {
            img.decode().catch(() => {});
        }
      }
    });

    processMissingCoords();
  } catch (error) {
    console.error("Erro ao obter clínicas: ", error);
  }
};

const processMissingCoords = async () => {
  for (const clinic of clinics.value) {
    if ((clinic.lat && clinic.lng) || clinicCoordinates[clinic.id]) continue;

    await new Promise(resolve => setTimeout(resolve, 1200)); // Rate limit safety
    
    const cleanAddress = clinic.address ? clinic.address.replace(/[^\w\s,.-]/gi, '') : '';
    const country = identifyCountry(clinic.address);
    const query = `${cleanAddress}, ${country}`;
    
    const latLng = await geocodeAddress(query);
    
    if (latLng) {
       clinicCoordinates[clinic.id] = latLng;
       try {
          const clinicRef = doc(db, "clinics", clinic.id);
          await updateDoc(clinicRef, {
              lat: latLng[0],
              lng: latLng[1]
          });
       } catch (e) {
          console.error("Erro ao salvar no DB", e);
       }
    }
  }
};

const geocodeAddress = async (address) => {
  try {
    const response = await fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(address)}&limit=1`, {
        headers: { 'User-Agent': 'OligoCheck-Clinic-Map/1.0' }
    });
    const data = await response.json();
    if (data && data.length > 0) {
      return [parseFloat(data[0].lat), parseFloat(data[0].lon)];
    }
  } catch (e) {
    console.warn("Geocoding error", e);
  }
  return null;
};

const selectClinic = async (clinic) => {
  const timestamp = Date.now();
  lastSelectionTimestamp.value = timestamp;

  // Se for o mesmo, não faz nada (evita fechar e abrir de novo)
  if (activeClinic.value?.id === clinic.id && sidebarVisible.value) return;

  if (sidebarVisible.value) {
      if (window.innerWidth <= 768) {
          // No mobile: fecha, espera a animação e abre a nova
          sidebarVisible.value = false;
          await new Promise(resolve => setTimeout(resolve, 500));
          
          // Se o usuário clicou em outro pino durante a animação, cancela esta ação
          if (lastSelectionTimestamp.value > timestamp) return;

      activeClinic.value = clinic;
          sidebarVisible.value = true;
      } else {
          // Desktop: troca imediata
          activeClinic.value = clinic;
      }
  } else {
      // Se fechado, seta e abre
      activeClinic.value = clinic;
      sidebarVisible.value = true;
  }
};

const closeSidebar = () => {
    sidebarVisible.value = false;
};

const handleImageError = (event) => {
  event.target.src = defaultImage;
};

const formatWhatsAppLink = (whatsappUrl) => {
  if (!whatsappUrl) return "https://wa.me";
  const correctedUrl = whatsappUrl.replace("was.me", "wa.me");
  if (correctedUrl.startsWith("https://wa.me/")) return correctedUrl;
  const match = correctedUrl.match(/(\d+)/);
  return match ? `https://wa.me/${match[0]}` : "https://wa.me";
};

const openLink = (url) => {
  window.open(url, "_blank");
};

const locateUser = () => {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        
        // Define localização do usuário para mostrar o pino vermelho
        userLocation.value = [latitude, longitude];
        
        // Garante que UI de busca/sidebar fechem
        closeSidebar();
        closeSearchModal();

        const mapInstance = map.value?.leafletObject;
        if (mapInstance) {
            mapInstance.flyTo([latitude, longitude], 13, {
                animate: true,
                duration: 2.0 // Um pouco mais lento para dar o efeito de "viagem"
            });
        } else {
            center.value = [latitude, longitude];
            zoom.value = 13;
        }
      },
      (error) => {
        console.warn("Erro ao obter localização:", error);
        // Opcional: alertar o usuário
      }
    );
  }
};

const handleClickOutside = (event) => {
  const langSwitcher = document.querySelector('.lang-switcher');
  if (showLangMenu.value && langSwitcher && !langSwitcher.contains(event.target)) {
    showLangMenu.value = false;
  }
};

onMounted(() => {
  fetchClinics();
  document.addEventListener('click', handleClickOutside);
});

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside);
});
</script>

<style scoped>
.mapa-wrapper {
  display: flex;
  width: 100%;
  height: 100vh; /* Tela cheia */
  position: relative;
  overflow: hidden;
}

/* Header Flutuante (Tipo Card) */
.floating-header {
  position: absolute;
  top: 30px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(16px);
  padding: 10px 30px;
  border-radius: 100px;
  box-shadow: 0 10px 40px rgba(0, 123, 255, 0.1), 0 2px 8px rgba(0,0,0,0.03);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  min-width: auto;
  gap: 0; /* Gap controlado internamente */
  border: 1px solid rgba(255,255,255,1);
  animation: headerSlideDown 0.8s cubic-bezier(0.2, 0.8, 0.2, 1) forwards;
}

@keyframes headerSlideDown {
  from {
    opacity: 0;
    transform: translate(-50%, -30px);
  }
  to {
    opacity: 1;
    transform: translate(-50%, 0);
  }
}

.floating-header:hover {
  transform: translateX(-50%) translateY(-2px);
  box-shadow: 0 15px 45px rgba(0, 123, 255, 0.15);
  background: rgba(255, 255, 255, 0.95);
}

.header-logo-link {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: 25px;
  margin-right: 25px;
  border-right: 1px solid rgba(0,0,0,0.06);
}

.header-logo-link img {
  height: 26px;
  width: auto;
  display: block;
  transition: transform 0.2s ease;
  transform: translateZ(0);
}

.header-logo-link:hover img {
  transform: scale(1.05);
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-right: 25px;
  margin-right: 25px;
  border-right: 1px solid rgba(0,0,0,0.06);
}

.icon-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  color: var(--cor-escuro-3);
  width: 38px;
  height: 38px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s cubic-bezier(0.2, 0.8, 0.2, 1);
  opacity: 0.75;
  position: relative;
}

.icon-btn:hover {
  color: var(--cor-azul);
  opacity: 1;
  background: rgba(0, 123, 255, 0.06);
  transform: translateY(-1px);
}

.icon-btn svg {
  width: 18px;
  height: 18px;
}

/* Tooltip Style */
.tooltip-text {
  visibility: hidden;
  background-color: #2c3e50;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 6px 10px;
  position: absolute;
  z-index: 10;
  top: 125%;
  left: 50%;
  transform: translateX(-50%) translateY(5px);
  opacity: 0;
  transition: all 0.25s cubic-bezier(0.2, 0.8, 0.2, 1);
  font-family: var(--regular);
  font-size: 11px;
  letter-spacing: 0.3px;
  white-space: nowrap;
  box-shadow: 0 4px 15px rgba(0,0,0,0.15);
  pointer-events: none;
}

.tooltip-text::after {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 50%;
  margin-left: -4px;
  border-width: 4px;
  border-style: solid;
  border-color: transparent transparent #2c3e50 transparent;
}

.icon-btn:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
  transform: translateX(-50%) translateY(0);
}

.lang-switcher {
  position: relative;
  display: flex;
  align-items: center;
}

.current-lang {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 6px 4px;
  border-radius: 30px;
  transition: all 0.2s;
  background: transparent;
  border: 1px solid transparent;
}

.current-lang:hover {
  background: rgba(0,0,0,0.04);
}

.flag-icon {
  width: 22px;
  height: 16px;
  object-fit: cover;
  border-radius: 3px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.lang-arrow {
  color: var(--cor-escuro-3);
  display: flex;
  align-items: center;
  opacity: 0.6;
  transition: opacity 0.2s;
}

.current-lang:hover .lang-arrow {
  opacity: 1;
}

.lang-menu {
  position: absolute;
  top: 135%; /* Um pouco mais abaixo para alinhar com tooltips */
  right: 0;
  background: #2c3e50; /* Fundo escuro igual tooltip */
  border-radius: 8px; /* Border radius menor como tooltip */
  box-shadow: 0 4px 15px rgba(0,0,0,0.15);
  padding: 6px;
  min-width: 140px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  overflow: visible; /* Visível para a seta (before) aparecer fora */
  border: none; /* Remove borda clara */
  animation: slideDown 0.2s cubic-bezier(0.16, 1, 0.3, 1);
  z-index: 2100;
}

/* Seta do menu de idiomas (igual tooltip) */
.lang-menu::before {
  content: "";
  position: absolute;
  bottom: 100%;
  right: 18px; /* Alinhado com a bandeira */
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent #2c3e50 transparent;
}

.lang-menu button {
  display: flex;
  align-items: center;
  gap: 10px;
  background: none;
  border: none;
  padding: 8px 12px;
  cursor: pointer;
  font-family: var(--regular);
  font-size: 13px; /* Fonte um pouco menor */
  color: rgba(255,255,255,0.8); /* Texto branco suave */
  border-radius: 6px;
  transition: all 0.2s;
  text-align: left;
}

.lang-menu button:hover {
  background: rgba(255,255,255,0.1); /* Hover sutil branco */
  color: #fff;
}

.lang-menu button.active {
  background: rgba(255,255,255,0.15);
  color: #fff;
  font-family: var(--bold);
}

.lang-menu button img {
  width: 18px; /* Bandeiras um pouco menores */
  border-radius: 2px;
  box-shadow: none; /* Remove sombra da bandeira no menu escuro */
}

@keyframes slideDown {
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
}

/* Layout do Mapa */
.map-content {
  flex: 1;
  height: 100%;
  width: 100%;
  z-index: 1;
  position: relative;
}

/* Controles Flutuantes (Botão) */
.floating-controls {
  position: absolute;
  bottom: 30px;
  left: 30px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: 15px;
  align-items: flex-start;
}

/* Botão Animado */
.cta-btn {
  background: linear-gradient(90deg, var(--cor-azul) 0%, #20e0ff 100%);
  color: white;
  font-family: var(--bold);
  font-size: 15px;
  padding: 16px 35px;
  border-radius: 50px;
  text-decoration: none;
  box-shadow: 0 10px 25px rgba(20, 203, 240, 0.5);
  transition: all 0.3s ease;
  border: none;
  text-transform: uppercase;
  letter-spacing: 1px;
  position: relative;
  overflow: hidden;
  animation: pulse-glow 2s infinite;
}

.cta-btn:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 35px rgba(20, 203, 240, 0.7);
}

@keyframes pulse-glow {
  0% {
    box-shadow: 0 0 0 0 rgba(32, 224, 255, 0.7);
  }
  70% {
    box-shadow: 0 0 0 15px rgba(32, 224, 255, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(32, 224, 255, 0);
  }
}

/* Sidebar */
.sidebar {
  position: absolute;
  top: 30px; /* Alinhado com o novo header flutuante e botão CTA */
  right: 30px;
  width: 380px;
  max-height: calc(100vh - 60px); /* Margem uniforme 30px em cima e baixo */
  background: rgba(255, 255, 255, 0.70);
  backdrop-filter: blur(12px);
  box-shadow: 0 15px 40px rgba(0,0,0,0.2);
  z-index: 1000;
  border-radius: 24px;
  
  /* Animação Aprimorada */
  transform: translateX(100px) scale(0.95);
  opacity: 0;
  visibility: hidden;
  transition: all 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
  
  display: flex;
  flex-direction: column;
}

.sidebar.open {
  transform: translateX(0) scale(1);
  opacity: 1;
  visibility: visible;
}

/* Conteúdo da Lista */
.clinics-list {
  flex: 1;
  overflow-y: auto;
  padding: 35px 25px 25px 25px; /* Padding superior para o botão close */
}

/* Botão Fechar Absoluto */
.close-btn-absolute {
  position: absolute;
  top: 15px;
  right: 15px;
  background: #f0f2f5;
  border: none;
  cursor: pointer;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  color: #888;
  z-index: 10;
}

.close-btn-absolute:hover {
  background: #e4e6e9;
  color: #333;
  transform: rotate(90deg);
}

.clinic-card {
  background: transparent;
  padding: 0;
}


/* Staggered Animation for Sidebar Content */
@keyframes slideInContent {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.clinic-header-profile {
  animation: slideInContent 0.5s cubic-bezier(0.2, 0.8, 0.2, 1) forwards;
  opacity: 0; /* Start hidden */
  animation-delay: 0.5s;
}

.divider {
  animation: slideInContent 0.5s cubic-bezier(0.2, 0.8, 0.2, 1) forwards;
  opacity: 0;
  animation-delay: 0.3s;
}

.clinic-actions-grid {
  animation: slideInContent 0.5s cubic-bezier(0.2, 0.8, 0.2, 1) forwards;
  opacity: 0;
  animation-delay: 0.4s;
}

.address-block {
  animation: slideInContent 0.8s cubic-bezier(0.2, 0.8, 0.2, 1) forwards;
  opacity: 0;
  animation-delay: 0.8s;
}

/* Clinic Profile Styles */
.clinic-header-profile {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: 25px;
}

.logo-wrapper {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  padding: 4px;
  background: white;
  box-shadow: 0 8px 20px rgba(0,0,0,0.1);
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.clinic-logo-large {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}

.text-content h4 {
  font-family: var(--bold);
  font-size: 22px;
  color: var(--cor-escuro-2);
  margin: 0 0 5px 0;
  line-height: 1.3;
}

.google-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background: #fff;
  padding: 4px 10px;
  border-radius: 20px;
  border: 1px solid #e0e0e0;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  margin-top: 5px;
}

.google-badge .stars {
  color: #fbbc04; /* Cor amarela do Google */
  font-family: var(--bold);
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 2px;
}

.google-badge .reviews {
  color: #5f6368;
  font-size: 12px;
  font-family: var(--regular);
}

.clinic-location {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  color: #666;
  font-size: 14px;
  font-family: var(--regular);
}

.divider {
  height: 1px;
  background: #f0f0f0;
  margin: 0 0 25px 0;
  width: 100%;
}

.clinic-actions-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
  margin-bottom: 30px;
}

.action-card {
  background: #fff;
  border: 1px solid #eee;
  border-radius: 16px;
  padding: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  transition: all 0.2s;
  text-decoration: none;
  height: 100%;
}

.action-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 5px 15px rgba(0,0,0,0.08);
  border-color: transparent;
}

.action-card .icon-box {
  width: 45px;
  height: 45px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}

.action-card span {
  font-size: 13px;
  font-family: var(--bold);
  color: var(--cor-escuro-2);
}

/* Cores Específicas */
.action-card.whatsapp .icon-box { background: #e0f2f1; color: #00897b; }
.action-card.maps .icon-box { background: #e3f2fd; color: #1565c0; }
.action-card.instagram .icon-box { background: #fce4ec; color: #c2185b; }
.action-card.website .icon-box { background: #f3e5f5; color: #7b1fa2; }

.action-card img {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.address-block {
  background: #f8f9fa;
  border-radius: 16px;
  padding: 20px;
  border: 1px solid #edf2f7;
}

.address-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #888;
  font-family: var(--bold);
  margin-bottom: 10px;
}

.address-block p {
  margin: 0;
  font-size: 14px;
  line-height: 1.6;
  color: var(--cor-escuro-2);
  font-family: var(--regular);
}

@media (max-width: 768px) {
  .clinic-actions-grid {
    grid-template-columns: 1fr 1fr; /* Mantém 2 colunas no mobile também para ficar bonito */
  }
}

.custom-tooltip {
  text-align: center;
  font-family: var(--bold);
  font-size: 13px;
  padding: 5px;
}

@media (max-width: 768px) {
  /* Header Mobile */
  .floating-header {
    top: 15px;
    width: 94%;
    max-width: 500px;
    padding: 8px 10px 8px 25px;
    justify-content: space-between;
    z-index: 3000; /* Garante que fique acima da sidebar mobile */
  }

  .header-logo-link {
    margin-right: 12px;
    padding-right: 12px;
    border-right: 1px solid rgba(0,0,0,0.06);
  }

  .header-logo-link img {
    height: 22px;
  }

  .header-actions {
    margin-right: 12px;
    padding-right: 12px;
    border-right: 1px solid rgba(0,0,0,0.06);
    gap: 2px;
  }

  .icon-btn {
    width: 34px;
    height: 34px;
  }

  .lang-switcher {
    transform: scale(0.9);
  }

  .sidebar {
    width: 100%;
    height: auto;
    max-height: 70vh;
    top: auto;
    bottom: 0;
    right: 0;
    border-radius: 24px 24px 0 0;
    
    /* Animation Mobile */
    transform: translateY(100%);
    opacity: 1;
    visibility: visible; /* Control opacity separately if needed */
    z-index: 2500;
    /* Remove overshoot effect specifically on mobile to avoid bottom gap */
    transition: transform 0.5s cubic-bezier(0.2, 0.8, 0.2, 1); 
  }
  
  .sidebar.open {
    transform: translateY(0);
    opacity: 1;
  }

  .floating-controls {
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    width: 90%;
    align-items: center;
  }
  
  .cta-btn {
    width: 100%;
    text-align: center;
    font-size: 12px;
    padding: 12px;
  }
}

/* Search Modal Styles */
.search-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2); /* Mais suave */
  backdrop-filter: blur(4px);
  z-index: 3000;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 100px; /* Mais abaixo */
  /* removed animation here */
}

.search-modal {
  background: rgba(255, 255, 255, 0.85); /* Glassmorphism */
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  width: 90%;
  max-width: 600px;
  border-radius: 24px;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  max-height: 60vh;
  /* removed animation here */
  border: 1px solid rgba(255,255,255,0.5);
}

/* Vue Transition Styles */
.search-anim-enter-active,
.search-anim-leave-active {
  transition: opacity 0.3s ease;
}

.search-anim-enter-from,
.search-anim-leave-to {
  opacity: 0;
}

.search-anim-enter-active .search-modal {
  animation: slideUpFade 0.4s cubic-bezier(0.2, 0.8, 0.2, 1);
}

.search-anim-leave-active .search-modal {
  animation: slideUpFade 0.3s cubic-bezier(0.2, 0.8, 0.2, 1) reverse;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideUpFade {
  from { opacity: 0; transform: translateY(20px) scale(0.98); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

.search-header {
  padding: 20px 25px;
  border-bottom: 1px solid rgba(0,0,0,0.05);
  display: flex;
  align-items: center;
  gap: 15px;
}

.input-wrapper {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 12px;
  background: rgba(255, 255, 255, 0.5);
  padding: 12px 18px;
  border-radius: 14px;
  color: var(--cor-escuro-3);
  border: 1px solid rgba(0,0,0,0.03);
  transition: all 0.2s;
}

.input-wrapper:focus-within {
  background: #fff;
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
  border-color: rgba(0,0,0,0.05);
}

.input-wrapper input {
  border: none;
  background: transparent;
  flex: 1;
  font-family: var(--regular);
  font-size: 16px;
  outline: none;
  color: var(--cor-escuro-1);
}

.input-wrapper input::placeholder {
  color: #999;
}

.close-search-btn {
  background: rgba(0,0,0,0.04);
  border: none;
  cursor: pointer;
  color: #666;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.close-search-btn:hover {
  background: rgba(0,0,0,0.08);
  color: #333;
  transform: rotate(90deg);
}

.search-results {
  overflow-y: auto;
  padding: 10px 0;
}

.search-result-item {
  padding: 15px 25px;
  display: flex;
  align-items: center;
  gap: 15px;
  cursor: pointer;
  transition: background 0.2s;
  border-bottom: 1px solid rgba(0,0,0,0.03);
}

.search-result-item:last-child {
  border-bottom: none;
}

.search-result-item:hover {
  background: rgba(0, 123, 255, 0.04);
}

.result-icon {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  overflow: hidden;
  background: #fff;
  border: 1px solid rgba(0,0,0,0.08);
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 5px rgba(0,0,0,0.05);
}

.result-icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.result-info {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.result-info strong {
  font-family: var(--bold);
  font-size: 15px;
  color: var(--cor-escuro-1);
}

.result-info small {
  font-size: 13px;
  color: var(--cor-escuro-3);
  font-family: var(--regular);
}

.no-results {
  padding: 40px;
  text-align: center;
  color: #888;
  font-size: 15px;
  font-family: var(--regular);
}

@media (max-width: 768px) {
  .search-modal-overlay {
    padding-top: 0;
    align-items: flex-start;
    background: rgba(255,255,255,0.5);
  }
  
  .search-modal {
    width: 100%;
    height: 100%;
    max-width: none;
    max-height: none;
    border-radius: 0;
    box-shadow: none;
    background: #f8f9fa; /* Fallback sólido ou manter glass se suportar bem */
  }

  .search-header {
    padding: 15px;
    background: white;
    box-shadow: 0 1px 10px rgba(0,0,0,0.05);
  }

  .close-search-btn {
     background: transparent;
  }
}

/* Login Modal Styles */
.login-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(4px);
  z-index: 3000;
  display: flex;
  justify-content: center;
  align-items: center; /* Centralizado */
}

.login-modal {
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(16px);
  width: 90%;
  max-width: 400px;
  border-radius: 24px;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(255,255,255,1);
}

.login-header {
  padding: 20px 25px;
  border-bottom: 1px solid rgba(0,0,0,0.05);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.login-header h3 {
  margin: 0;
  font-family: var(--bold);
  font-size: 18px;
  color: var(--cor-escuro-1);
}

.login-body {
  padding: 25px;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  font-size: 12px;
  font-family: var(--bold);
  color: var(--cor-escuro-2);
  margin-bottom: 5px;
  margin-left: 4px;
  text-transform: uppercase;
}

.btn-login {
  width: 100%;
  background: var(--cor-azul);
  color: white;
  border: none;
  padding: 14px;
  border-radius: 14px;
  font-family: var(--bold);
  font-size: 15px;
  cursor: pointer;
  transition: all 0.2s;
  margin-top: 10px;
}

.btn-login:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 123, 255, 0.3);
}

.btn-login:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.error-message {
  color: #e74c3c;
  font-size: 13px;
  background: rgba(231, 76, 60, 0.1);
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 15px;
  text-align: center;
}
</style>
